// src/marketing/content/statuses.ts
import type { ContentFormat, ContentKind, ContentPlatform, ContentStatus } from '../../lib/types'

export const CONTENT_STATUSES: ContentStatus[] = [
  'idea',
  'to_produce',
  'ready',
  'live',
  'archived',
]

// Libellé de colonne : « live » couvre les deux kinds (le badge de carte précise).
export const CONTENT_STATUS_LABELS: Record<ContentStatus, string> = {
  idea: 'Idée',
  to_produce: 'À produire',
  ready: 'Prêt',
  live: 'En diffusion / Publié',
  archived: 'Archivé',
}

// Mapping statique status → data-testid (colonnes kanban — requis pour grep spec) :
// data-testid="content-col-idea"
// data-testid="content-col-to_produce"
// data-testid="content-col-ready"
// data-testid="content-col-live"
// data-testid="content-col-archived"
export const CONTENT_STATUS_TEST_IDS: Record<ContentStatus, string> = {
  idea: 'content-col-idea',
  to_produce: 'content-col-to_produce',
  ready: 'content-col-ready',
  live: 'content-col-live',
  archived: 'content-col-archived',
}

export const KIND_LABELS: Record<ContentKind, string> = {
  ad: 'Créa ads',
  organic: 'Organique',
}

export const FORMAT_LABELS: Record<ContentFormat, string> = {
  video: 'Vidéo',
  image: 'Image',
  carousel: 'Carrousel',
  text: 'Texte',
  other: 'Autre',
}

export const PLATFORM_LABELS: Record<ContentPlatform, string> = {
  tiktok: 'TikTok',
  instagram_reels: 'Instagram Reels',
  instagram_post: 'Instagram Post',
  x: 'X / Twitter',
  reddit: 'Reddit',
  youtube: 'YouTube',
  apple_search_ads: 'Apple Search Ads',
  app_store: 'App Store',
  other: 'Autre',
}

/** Libellé du statut « live » selon le kind (spec §2.1). */
export function liveLabel(kind: ContentKind): string {
  return kind === 'ad' ? 'En diffusion' : 'Publié'
}
